<template>
  <div
    class="header-navbar"
    v-if="checkOnDevice()[0] || checkOnDevice()[2]"
  >
    <!------   Left exit button ------>
    <router-link :to="routePrev">
      <template v-if="leaveRoadBookLeft">
        <rc-restart-button
          v-if="
            route.name &&
            typeof route.name === 'string' &&
            ['roadbook_edit', 'client_info', 'roadbookPreview'].includes(route.name) &&
            !isFinished
          "
          :text="$t('btn.abandon')"
          small
          class="leaveRoadBookLeft"
        />
        <div
          class="leaveRoadBookLeft"
          v-else
        >
          <RcSvg
            class="leaveIcon"
            name="incorrect"
            @click="emit('back')"
          />
          <span class="leave-text">{{ $t('btn.quit') }}</span>
        </div>
      </template>

      <RcSvg
        v-else-if="!hidePrev"
        class="navbar-icon prev"
        name="next"
        @click="emit('back')"
      />
    </router-link>
    <span
      v-if="navbarTitle"
      class="navbar-title"
      >{{ navbarTitle }}</span
    >
    <router-link :to="routeNext">
      <div
        v-if="leaveRoadBookRight"
        class="leaveRoadBookRight"
      >
        <RcSvg
          class="leaveIcon"
          name="incorrect"
        />
        <span class="leave-text">{{ $t('btn.quit') }}</span>
      </div>
      <RcSvg
        v-else-if="!hideNext"
        class="navbar-icon next"
        name="next"
      />
    </router-link>
  </div>
</template>

<script setup lang="ts">
  import { useMixin } from '@/utils/mixins/useMixin.mixin';
  import RcSvg from '@/components/medias/RcSvg.vue';
  import { useRoute } from 'vue-router';
  import { useRoadbookStore } from '@/store';
  import { computed } from 'vue';
  import RcRestartButton from '@/components/inputs/RcRestartButton.vue';

  // General
  const { checkOnDevice } = useMixin();
  const route = useRoute();

  const emit = defineEmits(['back']);

  defineProps({
    hidePrev: {
      type: Boolean,
      default: false,
    },
    routePrev: {
      type: String,
      default: '/',
    },
    hideNext: {
      type: Boolean,
      default: false,
    },
    routeNext: {
      type: String,
      default: '/',
    },
    navbarTitle: {
      type: String,
      default: '',
    },
    leaveRoadBookLeft: {
      type: Boolean,
      default: false,
    },
    leaveRoadBookRight: {
      type: Boolean,
      default: false,
    },
  });

  const isFinished = computed(() => useRoadbookStore().metadata.is_finished);
</script>

<style lang="postcss">
  .header-navbar {
    @apply w-full bg-white border-b flex justify-between items-center gap-[15px] px-[30px] py-6;

    @media screen and (min-width: 1024px) {
      @apply hidden;
    }
    .leaveRoadBookLeft {
      @apply flex flex-col items-center absolute top-[20px] left-[20px];
      .leaveIcon {
        @apply w-[20px] h-[20px] fill-red-500 stroke-none;
        path {
          @apply fill-red-500;
        }
        #Ellipse_360 {
          @apply stroke-red-500;
        }
      }
      .leave-text {
        @apply text-red-500 font-semibold text-[10px];
      }
    }
    .leaveRoadBookRight {
      @apply flex flex-col items-center absolute top-[20px] right-[20px];
      .leaveIcon {
        @apply w-[20px] h-[20px] fill-red-500 stroke-none;
        path {
          @apply fill-red-500;
        }
        #Ellipse_360 {
          @apply stroke-red-500;
        }
      }
      .leave-text {
        @apply text-red-500 font-semibold text-[10px];
      }
    }

    .navbar-icon {
      @apply fill-primary;

      path {
        @apply fill-primary;
      }

      &.prev {
        @apply rotate-180;
      }
    }

    .navbar-title {
      @apply text-center font-semibold text-grey-darkest;
    }
  }
</style>
